import { render, staticRenderFns } from "./SecureDocsList.vue?vue&type=template&id=3ed44764&scoped=true&"
import script from "./SecureDocsList.vue?vue&type=script&lang=js&"
export * from "./SecureDocsList.vue?vue&type=script&lang=js&"
import style0 from "./SecureDocsList.vue?vue&type=style&index=0&id=3ed44764&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed44764",
  null
  
)

export default component.exports